"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var rowMenu = 'rowMenu';
var rowNumber = 'rowNumber';
var _default = exports["default"] = {
  rowMenu: rowMenu,
  rowNumber: rowNumber
};